import { cloneDeep } from 'lodash-es';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NewProjectNameComponent } from '../new-project-name/new-project-name.component';
import { Subject, first, map, takeUntil } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ZalamoDialogService } from '../../../../zalamo-dialog/zalamo-dialog.service';
import { MissingPhotosListComponent } from '../missing-photos-list/missing-photos-list.component';
import { AvailableProduct } from '../../../shopping-cart-back/actions/standalone';
import { selectPackagesInShop } from '../../../shopping-cart-back/actions/selector';
import { TypedFormBuilder } from '../../../../form/TypedFormBuilder';
import { CustomProductAttributeConfig } from '../../../types';
import { parseProductConfigEntry } from '../../helpers';

import { addProductInPackageToBasketAction } from '../../../shopping-cart-back/actions/actions';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/graphql';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
  selector: 'lib-preview-product-in-basket',
  templateUrl: './preview-product-in-basket.component.html',
  styleUrls: ['./preview-product-in-basket.component.scss'],
  providers: [translationProvider('productFront')],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PreviewProductInBasketComponent implements OnInit {
  @Input() product: AvailableProduct;
  @Input() quantity = 1;
  @Input() photoIdList: Array<{ photoId: string }> = [];
  @Input() swap = false;
  @Input() packageId: string;
  @Input() packageInBasketId: string;
  @Input() max = 0;
  @Input() config: { [x: string]: any };
  @Input() selectedProductId = '';
  @Input() nameClientProduct = '';
  @Input() productInPackageId = '';
  @Input() inPackage = false;
  @Input() photosSelectedByPhotographer: {
    photos: Array<{ photoId: string }>;
    mode: string;
  };
  @Input() @Required context: ZalamoObject;
  @Input() @Required contextId: string;
  copyConfiguration: Array<CustomProductAttributeConfig> = [];
  filtered: Array<CustomProductAttributeConfig> = [];
  currentNumber = 1;
  @Output() hideDialog = new EventEmitter();
  packagesInShop$ = this.store.pipe(select(selectPackagesInShop));
  model = this.fb.group({});
  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));
  @ViewChild('messageAboutNoPhotosToBeAdded')
  messageAboutNoPhotosToBeAdded;
  images = {
    imagesRequired: false,
    requiredImages: { max: 0, min: 0 },
  };
  closeDialog$ = new Subject<boolean>();

  constructor(
    private screenObserver: BreakpointObserver,
    private dialogService: ZalamoDialogService,
    private store: Store,
    private fb: TypedFormBuilder,
  ) {}

  ngOnInit() {
    console.table(this.photosSelectedByPhotographer);
    this.images.imagesRequired = this.product.imagesRequired;
    this.images.requiredImages = this.product.requiredImages;
    let configuration = '';
    const filtered = [];
    this.packagesInShop$
      .pipe(first())
      .subscribe(
        (value1) =>
          (configuration = value1.package
            .find((value2) => value2.packageId === this.packageId)
            .productConfig.find(
              (value3) => value3.productInPackageId === this.productInPackageId,
            ).config),
      );
    let newConfig = {};
    this.product.config.forEach((x) => {
      console.table(x);
      const config = cloneDeep(x);
      const attribute: {} = Object.entries(JSON.parse(configuration)).find(
        (value) => value[0] === config.customId,
      );
      if (attribute) {
        switch (config.type) {
          case 'boolean':
            newConfig = {
              ...newConfig,
              [config.customId]: attribute[1].value,
            };
            break;
          case 'list':
          case 'decoration':
          case 'size':
            newConfig = {
              ...newConfig,
              [config.customId]: attribute[1].value[0],
            };
            const option = config.options.find(
              ({ configId }) => configId === attribute[1].value[0],
            );
            if (option && option.hasRequiredImagesModifier) {
              this.images.imagesRequired = option.hasRequiredImagesModifier;
              this.images.requiredImages = option.requiredImagesModifier;
            }
            break;

          case 'counter':
            let text = '';
            if (this.config) {
              text = Object.entries(this.config).find(
                (value1) => value1[0] === config.customId,
              )[1];
            }
            if (text) {
              newConfig = {
                ...newConfig,
                [config.customId]: text,
              };
            } else {
              newConfig = {
                ...newConfig,
                [config.customId]: attribute[1].min,
              };
            }
            config.counterConfig.min = attribute[1].min;
            config.counterConfig.max = attribute[1].max;
            break;
        }
        this.copyConfiguration.push({ ...config });
      } else {
        if (config.type === 'text' || config.type === 'file') {
          let text = '';
          if (this.config) {
            text = Object.entries(this.config).find(
              (value1) => value1[0] === config.customId,
            )?.[1];
          }
          if (text) {
            newConfig = {
              ...newConfig,
              [config.customId]: text,
            };
          }
          this.copyConfiguration.push({ ...config });
        }
      }
    });
    parseProductConfigEntry(
      this.copyConfiguration,
      this.model,
      newConfig,
      filtered,
      true,
      true,
      true,
      true,
    );
    if (JSON.stringify(this.filtered) !== JSON.stringify(filtered)) {
      this.filtered = filtered;
      this.model.patchValue(newConfig);
    }
    if (
      this.images.requiredImages.min ===
      this.photosSelectedByPhotographer.photos.length
    ) {
      this.photoIdList = this.photosSelectedByPhotographer.photos;
    }
    if (!this.images.imagesRequired) {
      this.photoIdList = [];
    }
  }

  addToBasket() {
    if (this.currentNumber >= 1 && this.currentNumber <= this.max) {
      // const ref = this.dialogService.openFull(NewProjectNameComponent);
      // ref.componentInstance.model.patchValue({
      //   name: this.nameClientProduct,
      // });
      // ref.componentInstance.saved
      //   .pipe(takeUntil(ref.afterClosed()))
      //   .subscribe((productName) => {
      this.store.dispatch(
        addProductInPackageToBasketAction({
          packageInBasketId: this.packageInBasketId,
          product: {
            productId: this.product.productId,
            productInPackageId: this.productInPackageId,
            count: this.currentNumber,
            // nameClientProduct: productName,
            photos: this.photoIdList,
            config: this.model.value,
            selectedProductId: this.selectedProductId,
            photosAddedByCustomer: false,
          },
        }),
      );
      // ref.close();
      this.hideDialog.emit();
      // });
    }
  }

  swapToBasket() {
    if (this.currentNumber >= 1 && this.currentNumber <= this.max) {
      const ref = this.dialogService.openFull(NewProjectNameComponent);
      ref.componentInstance.model.patchValue({
        name: this.nameClientProduct,
      });
      ref.componentInstance.saved
        .pipe(takeUntil(ref.afterClosed()))
        .subscribe((productName) => {
          ref.close();
          this.store.dispatch(
            addProductInPackageToBasketAction({
              packageInBasketId: this.packageInBasketId,
              product: {
                productId: this.product.productId,
                productInPackageId: this.productInPackageId,
                count: this.currentNumber,
                nameClientProduct: productName,
                photos: this.photoIdList,
                config: this.model.value,
                selectedProductId: this.selectedProductId,
                photosAddedByCustomer: false,
              },
            }),
          );
          this.hideDialog.emit();
        });
      if (
        this.photosSelectedByPhotographer.photos.length <
          this.product.requiredImages.min &&
        this.photoIdList.length < this.product.requiredImages.min
      ) {
        const message = this.dialogService.openFull(
          this.messageAboutNoPhotosToBeAdded,
        );
        this.closeDialog$
          .pipe(takeUntil(message.afterClosed()))
          .subscribe(() => message.close());
      }
    }
  }

  addMissingPhotos() {
    if (this.currentNumber >= 1 && this.currentNumber <= this.max) {
      const missingPhotosList = this.dialogService.openFull(
        MissingPhotosListComponent,
      );
      this.isPhonePortrait$
        .pipe(takeUntil(missingPhotosList.afterClosed()))
        .subscribe(
          (isPhonePortrait) =>
            (missingPhotosList._containerInstance.isBare = isPhonePortrait),
        );
      missingPhotosList.componentInstance.photoIdList = this.photoIdList;
      missingPhotosList.componentInstance.photosSelectedByPhotographer =
        this.photosSelectedByPhotographer.photos;
      missingPhotosList.componentInstance.swap = this.swap;
      missingPhotosList.componentInstance.context = this.context;
      missingPhotosList.componentInstance.contextId = this.contextId;
      if (this.product.imagesRequired) {
        missingPhotosList.componentInstance.maxPhoto =
          this.images.requiredImages.max;
      } else {
        missingPhotosList.componentInstance.maxPhoto = 1;
      }
      missingPhotosList.componentInstance.closeDialog
        .pipe(takeUntil(missingPhotosList.afterClosed()))
        .subscribe(() => missingPhotosList.close());
      missingPhotosList.componentInstance.addProduct
        .pipe(takeUntil(missingPhotosList.afterClosed()))
        .subscribe((photoList) => {
          // const newProjectName = this.dialogService.openFull(
          //   NewProjectNameComponent
          // );
          // newProjectName
          //   .afterOpened()
          //   .pipe(first())
          //   .subscribe(() => missingPhotosList.close());
          // newProjectName.componentInstance.saved.next(this.nameClientProduct);
          // newProjectName.componentInstance.saved
          //   .pipe(takeUntil(newProjectName.afterClosed()))
          //   .subscribe((productName) => {
          //     newProjectName.close();
          this.store.dispatch(
            addProductInPackageToBasketAction({
              packageInBasketId: this.packageInBasketId,
              product: {
                productId: this.product.productId,
                productInPackageId: this.productInPackageId,
                count: this.currentNumber,
                // nameClientProduct: productName,
                photos: photoList,
                config: this.model.value,
                selectedProductId: this.selectedProductId,
                photosAddedByCustomer: true,
              },
            }),
          );
          missingPhotosList.close();
          this.hideDialog.emit();
          // });
        });
      missingPhotosList.componentInstance.swapProduct
        .pipe(takeUntil(missingPhotosList.afterClosed()))
        .subscribe((photoList) => {
          const newProjectName = this.dialogService.openFull(
            NewProjectNameComponent,
          );
          newProjectName
            .afterOpened()
            .pipe(first())
            .subscribe(() => missingPhotosList.close());
          newProjectName.componentInstance.model.patchValue({
            name: this.nameClientProduct,
          });
          newProjectName.componentInstance.saved
            .pipe(takeUntil(newProjectName.afterClosed()))
            .subscribe((productName) => {
              newProjectName.close();
              this.store.dispatch(
                addProductInPackageToBasketAction({
                  packageInBasketId: this.packageInBasketId,
                  product: {
                    productId: this.product.productId,
                    productInPackageId: this.productInPackageId,
                    count: this.currentNumber,
                    nameClientProduct: productName,
                    photos: photoList,
                    config: this.model.value,
                    selectedProductId: this.selectedProductId,
                    photosAddedByCustomer: true,
                  },
                }),
              );
              this.hideDialog.emit();
            });
        });
    }
  }
}
